module.exports = __webpack_public_path__ + "images/icon-new-york-yellow.svg";